import { ITenant } from 'app/shared/model/tenant.model';
import { IUser } from 'app/shared/model/user.model';
import { IContactDetails } from 'app/shared/model/contact-details.model';
import { Gender } from 'app/shared/model/enumerations/gender.model';
import { BloodGroup } from 'app/shared/model/enumerations/blood-group.model';
import { LabServiceType } from 'app/shared/model/enumerations/lab-service-type.model';

export interface ITenantEmployee {
  id?: string;
  name?: string | null;
  email?: string | null;
  education?: string | null;
  training?: string | null;
  experience?: string | null;
  achievements?: string | null;
  dateOfBirth?: number | null;
  gender?: keyof typeof Gender | null;
  bloodGroup?: keyof typeof BloodGroup | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  exited?: boolean | null;
  labServiceType?: keyof typeof LabServiceType | null;
  tenant?: ITenant | null;
  user?: IUser | null;
  contactCode?: IContactDetails | null;
}

export const defaultValue: Readonly<ITenantEmployee> = {
  active: false,
  exited: false,
};
